import type { ReactNode, JSX} from "react";
import { Row } from "./Row";

export interface ModuleDetailHeaderProps {
  readonly left: ReactNode;
  readonly actions?: ReactNode;
}

/**
 * Standard detail pane header with left info and right actions.
 * Used across all plugin detail views.
 */
export function ModuleDetailHeader({ left, actions }: ModuleDetailHeaderProps): JSX.Element {
  return (
    <Row align="center" justify="between" className="h-full w-full">
      {left}
      {actions && <Row gap={2} align="center">{actions}</Row>}
    </Row>
  );
}
